/* eslint-disable react/display-name */
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import {
  Avatar,
  Badge,
  Button,
  InputNumber,
  notification,
  Space,
  TableColumnType,
  Tooltip,
} from 'antd'
import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { OweMoneyIcon } from '../../../compnents/icons/Icons'
import { Dimen } from '../../../models/dimen'
import {
  getInvoiceType,
  getOrderSource,
  getPayFlagName,
  Payment,
  PaymentStatus,
} from '../../../models/payment'
import { RecipeStatus } from '../../../models/recipe'
import { getGenderName } from '../../../models/user'
import { getAge } from '../../../utils/StringUtils'
import { selectSettings, selectTenant } from '../../user/setting/settingSlice'
import styles from './Payments.module.css'
import { ColDef } from 'ag-grid-community'
import { Checks } from '../../../models/setting'

type Action =
  | 'pay'
  | 'return'
  | 'detail'
  | 'upload'
  | 'repeal'
  | 'supplementary'
  | 'payAgain'
  | 'check'

export const getCardType = (cardType: string) => {
  switch (cardType) {
    case '1':
      return '电子凭证'
    case '2':
      return '身份证'
    case '3':
      return '医保卡'
    default:
      return ''
  }
}

export const getInsuranceCodeName = (insuranceCode: string) => {
  switch (insuranceCode) {
    case 'ZIFEI':
      return '自费'
    case 'ZHEJIANG':
      return '浙江智慧医保'
    case 'CHONGQING':
      return '重庆医保'
    default:
      return ''
  }
}

export const PaymentColumns = (
  //待收费
  _: PaymentStatus,
  startIndex: number,
  onAction: (
    action: Action,
    id: string,
    t: any,
    settlementCategory?: number
  ) => void
): TableColumnType<Payment>[] => {
  const oweMoneyShow: any = useSelector(selectTenant) //欠费是否显示
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      fixed: 'left',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '门诊号',
      key: 'outpatientNo',
      width: Dimen.OutpatientNo,
      align: 'center',
      fixed: 'left',
      render: (_, { registration }) => registration.outpatientNo,
    },
    {
      title: '患者姓名',
      key: 'patientName',
      align: 'center',
      width: '8rem',
      fixed: 'left',
      // ellipsis:true,
      render: (_, { treatment, arrearageAmountSum, registration, labels }) => {
        return (
          <div style={{ width: '100%', height: '100%' }}>
            {/* {registration.insuranceCode ? (
              <Badge
                offset={[0, 10]}
                dot={true}
                color={
                  registration.insuranceCode === 'ZHEJIANG'
                    ? '#07BD4F'
                    : registration.insuranceCode === 'ZIFEI'
                    ? '#9B3EDF'
                    : ''
                }
              >
                <div style={{ width: '100%', height: '100%' }}>
                  {treatment.patientName}
                </div>
              </Badge>
            ) : ( */}
            <div style={{}}>
              <div
                style={{ width: '100%', height: '40px', lineHeight: '40px' }}
              >
                {treatment.patientName}
              </div>
              {/* {arrearageAmountSum > 0 &&
                oweMoneyShow &&
                oweMoneyShow?.openOwe == 1 && (
                  <Tooltip title={`欠费金额 ${arrearageAmountSum} 元`}>
                    <div>
                      <OweMoneyIcon
                        style={{
                          marginLeft: '5px',
                          width: '18px',
                          height: '18px',
                        }}
                      />
                    </div>
                  </Tooltip>
                )}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: labels?.length ? '8px' : '0px',
                }}
              >
                {!!labels?.length &&
                  labels?.map((v: any) => (
                    <Tooltip key={v.id} title={v.name}>
                      <span
                        className={styles.label}
                        style={{
                          backgroundColor: v.backgroundColor,
                          color: v.fontColor,
                        }}
                      >
                        {v.headName}
                      </span>
                    </Tooltip>
                  ))}
              </div> */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: labels?.length ? '8px' : '0px',
                }}
              >
                {arrearageAmountSum > 0 &&
                  oweMoneyShow &&
                  oweMoneyShow?.openOwe == 1 && (
                    <Tooltip title={`欠费金额 ${arrearageAmountSum} 元`}>
                      <span
                        style={{
                          width: '18px',
                          height: '18px',
                          lineHeight: '18px',
                          marginBottom: labels?.length ? '0px' : '8px',
                        }}
                      >
                        <OweMoneyIcon
                          style={{
                            marginRight: '3px',
                            width: '18px',
                            height: '18px',
                          }}
                        />
                      </span>
                    </Tooltip>
                  )}
                {!!labels?.length &&
                  labels?.map((v: any) => (
                    <Tooltip key={v.id} title={v.name}>
                      <span
                        className={styles.label}
                        style={{
                          backgroundColor: v.backgroundColor,
                          color: v.fontColor,
                          borderRadius: '50%',
                        }}
                      >
                        {v.headName}
                      </span>
                    </Tooltip>
                  ))}
              </div>
            </div>
            {/* )} */}
          </div>
        )
        // return treatment.patientName
      },
    },
    {
      title: '病历号',
      dataIndex: 'patientId',
      key: 'patientId',
      align: 'center',
      width: '8rem',
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '8em',
      align: 'center',
      render: (_, { registration }) => {
        return registration.insuranceCode === 'ZIFEI' ||
          !registration.insuranceCode
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '读卡方式',
      key: 'cardType',
      align: 'center',
      width: '8em',
      render: (_, { registration }) => {
        return getCardType(registration.cardType)
      },
    },
    {
      title: '性别',
      key: 'patientSex',
      align: 'center',
      width: Dimen.Sex,
      render: (_, { treatment }) => getGenderName(treatment.patientSex),
    },
    {
      title: '年龄',
      key: 'patientAge',
      align: 'center',
      width: Dimen.Age,
      render: (_, { treatment }) =>
        getAge(treatment?.patientAge, treatment?.patientMonth),
    },
    {
      title: '诊断疾病',
      key: 'disease',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, { treatment }) => treatment?.disease,
    },

    {
      title: '接诊科室',
      key: 'treatmentDepartmentName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, { treatment }) => treatment.treatmentDepartmentName,
    },
    {
      title: '接诊医生',
      key: 'treatmentDoctorName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, { treatment }) => treatment.treatmentDoctorName,
    },
    // {
    //   title: '诊断疾病',
    //   key: 'disease',
    //   align: 'center',
    //   width: '8rem',
    //   ellipsis: true,
    //   render: (_, { treatment }) => ({
    //     props: {
    //       style: {
    //         maxWidth: '14rem',
    //         overflow: 'hidden',
    //         textOverflow: 'ellipsis',
    //       },
    //     },
    //     children: treatment.disease,
    //   }),
    // },
    {
      title: '总金额',
      key: 'amount',
      width: '6em',
      align: 'right',
      render: (_, { amount }) =>
        amount === undefined ? '' : amount?.toFixed(2),
    },
    {
      title: '订单来源',
      key: 'orderSource',
      align: 'center',
      width: '8em',
      render: (_, { orderSource }) => getOrderSource(orderSource),
    },
    {
      title: '收费标志',
      key: 'settlementCategory',
      align: 'center',
      width: '8em',
      render: (_, { settlementCategory }) => getPayFlagName(settlementCategory),
    },
    {
      title: '挂号时间',
      key: 'registrationTime',
      align: 'center',
      width: Dimen.Time,
      render: (_, { registration }) => registration.registrationTime,
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '5rem',
      fixed: 'right',
      render: function ShowAction(_, t): ReactElement {
        return (
          <Button
            size='small'
            type='primary'
            onClick={() =>
              onAction('pay', t.treatment.id, t, t.settlementCategory)
            }
          >
            结算
          </Button>
        )
      },
    },
  ]
}

export const PaymentColumnsWithAmount = (
  //已收费
  status: PaymentStatus,
  startIndex: number,
  onAction: (
    action: Action,
    id: any,
    t: any,
    settlementCategory?: number
  ) => void,
  YBZFUploadflag?: boolean,
  LSCFSHflag?: boolean,
  auditButtonLoading?: any
): TableColumnType<Payment>[] => {
  const oweMoneyShow: any = useSelector(selectTenant) //欠费是否显示

  const colums: TableColumnType<Payment>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      fixed: 'left',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '门诊号',
      key: 'outpatientNo',
      align: 'center',
      fixed: 'left',
      width: Dimen.OutpatientNo,
      render: (_, { registration }) => registration.outpatientNo,
    },
    {
      title: '患者姓名',
      key: 'patientName',
      align: 'center',
      width: '8rem',
      fixed: 'left',
      // ellipsis:true,
      render: (_, { treatment, arrearageAmountSum, registration, labels }) => {
        return (
          <div style={{ width: '100%', height: '100%' }}>
            {/* {registration.insuranceCode ? (
              <Badge
                offset={[0, 10]}
                dot={true}
                color={
                  registration.insuranceCode === 'ZHEJIANG'
                    ? '#07BD4F'
                    : registration.insuranceCode === 'ZIFEI'
                    ? '#9B3EDF'
                    : ''
                }
              >
                <div style={{ width: '100%', height: '100%' }}>
                  {treatment.patientName}
                </div>
              </Badge>
            ) : ( */}
            <div style={{}}>
              <div
                style={{ width: '100%', height: '40px', lineHeight: '40px' }}
              >
                {treatment.patientName}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: labels?.length ? '8px' : '0px',
                }}
              >
                {arrearageAmountSum > 0 &&
                  oweMoneyShow &&
                  oweMoneyShow?.openOwe == 1 && (
                    <Tooltip title={`欠费金额 ${arrearageAmountSum} 元`}>
                      <span
                        style={{
                          width: '18px',
                          height: '18px',
                          lineHeight: '18px',
                          marginBottom: labels?.length ? '0px' : '8px',
                        }}
                      >
                        <OweMoneyIcon
                          style={{
                            marginRight: '3px',
                            width: '18px',
                            height: '18px',
                            borderRadius: '50%',
                          }}
                        />
                      </span>
                    </Tooltip>
                  )}
                {!!labels?.length &&
                  labels?.map((v: any) => (
                    <Tooltip key={v.id} title={v.name}>
                      <span
                        className={styles.label}
                        style={{
                          backgroundColor: v.backgroundColor,
                          color: v.fontColor,
                          borderRadius: '50%',
                        }}
                      >
                        {v.headName}
                      </span>
                    </Tooltip>
                  ))}
              </div>
            </div>
            {/* )} */}
          </div>
        )
        // return treatment.patientName
      },
    },
    {
      title: '病历号',
      key: 'patientId',
      align: 'center',
      width: '8em',
      dataIndex: 'patientId',
      render: (_, { registration }) => registration.patientId,
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '8em',
      align: 'center',
      render: (_, _2) => {
        return _2.paymentInsuranceCode === 'ZIFEI' || !_2.paymentInsuranceCode
          ? '自 费'
          : '智慧医保'
      },
    },

    {
      title: '读卡方式',
      key: 'cardType',
      align: 'center',
      width: '6em',
      render: (_, { registration }) => {
        return getCardType(registration.cardType)
      },
    },
    {
      title: '性别',
      key: 'patientSex',
      align: 'center',
      width: '4em',
      render: (_, { treatment }) => getGenderName(treatment.patientSex),
    },
    {
      title: '年龄',
      key: 'patientAge',
      align: 'center',
      width: '4em',
      render: (_, { treatment }) =>
        getAge(treatment?.patientAge, treatment?.patientMonth),
    },
    {
      title: '诊断疾病',
      key: 'disease',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, { treatment }) => treatment?.disease,
    },
    {
      title: '接诊科室',
      key: 'treatmentDepartmentName',
      align: 'center',
      width: '8em',
      render: (_, { treatment }) => treatment.treatmentDepartmentName,
    },
    {
      title: '接诊医生',
      key: 'treatmentDoctorName',
      align: 'center',
      width: '8em',
      render: (_, { treatment }) => treatment.treatmentDoctorName,
    },
    {
      title: '报销金额',
      key: 'insurancePayAmount',
      align: 'right',
      width: '8em',
      render: (_, { insurancePayAmount }) =>
        insurancePayAmount === undefined ? '' : insurancePayAmount?.toFixed(2),
    },
    {
      title: '现金金额',
      key: 'realPayAmount',
      align: 'right',
      width: '8em',
      render: (_, { realPayAmount }) =>
        realPayAmount === undefined ? '' : realPayAmount?.toFixed(2),
    },
    {
      title: '总金额',
      key: 'amount',
      width: '8em',
      align: 'right',
      render: (_, { amount }) =>
        amount === undefined ? '' : amount?.toFixed(2),
    },
    {
      title: '应收金额',
      key: 'shouldPayAmount',
      width: '8em',
      align: 'right',
      render: (_, { shouldPayAmount }) =>
        shouldPayAmount === undefined ? '' : shouldPayAmount?.toFixed(2),
    },
    {
      title: '优惠金额',
      key: 'discountAmount',
      width: '8em',
      align: 'right',
      render: (_, { discountAmount }) =>
        discountAmount === undefined ? '' : discountAmount?.toFixed(2),
    },
    // {
    //   title: '欠费补缴金额',
    //   key: 'realPayAmount',
    //   align: 'right',
    //   width: '10em',
    //   render: (
    //     _,
    //     { shouldPayAmount, realPayAmount, arrearageAmount, accountingStatus }
    //   ) =>
    //     accountingStatus === 0
    //       ? '-'
    //       : ((realPayAmount || 0) - (arrearageAmount || 0))?.toFixed(2),
    // },
    {
      title: '欠费金额',
      key: 'arrearageAmount',
      align: 'right',
      width: '8em',
      render: (_, { realPayAmount, arrearageAmount, accountingStatus }) =>
        accountingStatus === 0
          ? '-'
          : arrearageAmount && arrearageAmount.toFixed(2),
    },
    {
      title: '收款人',
      key: 'payee',
      align: 'right',
      width: '8em',
      render: (_, { treatment }) => treatment.payeeName,
    },
    {
      title: '订单来源',
      key: 'orderSource',
      align: 'center',
      width: '8em',
      render: (_, { orderSource }) => getOrderSource(orderSource),
    },
    {
      title: '收费标志',
      key: 'settlementCategory',
      align: 'center',
      width: '7em',
      render: (_, { treatment }) =>
        getPayFlagName(treatment.settlementCategory),
    },
    {
      title: '结算状态',
      key: 'accountingStatus',
      width: Dimen.Price,
      align: 'center',
      render: (_, { accountingStatus }) =>
        accountingStatus === 0 ? '已结清' : '欠费中',
    },
    {
      title: '收费时间',
      key: 'payTime',
      align: 'center',
      width: Dimen.Time,
      render: (_, { treatment }) => treatment.payTime,
    },
    {
      title: status === RecipeStatus.Settled ? '收费时间' : '退费时间',
      key: 'chargeOrRefundTime',
      align: 'center',
      width: Dimen.Time,
      render: (_, { treatment }) => treatment.chargeOrRefundTime,
    },
    {
      title: '支付方式',
      dataIndex: 'payMethodName',
      width: Dimen.PayMethod,
      align: 'center',
      key: 'payMethodName',
      render: (_, t) => {
        return t.payMethodName
      },
    },
    {
      title: '发票类型',
      key: 'invoiceType',
      align: 'center',
      width: '8em',
      render: (_, t) => getInvoiceType(t.invoiceDetails.invoiceType),
    },
    {
      title: '发票号',
      key: 'invoiceNo',
      align: 'center',
      width: '8em',
      render: (_, t) => t.invoiceDetails.invoiceNum || '-',
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '12rem',
      fixed: 'right',
      render: function ShowAction(_, t): ReactElement {
        {
          return LSCFSHflag ? (
            <Button
              loading={auditButtonLoading}
              disabled={auditButtonLoading}
              size='small'
              type='primary'
              onClick={() => onAction('check', t.id, t)}
            >
              审核
            </Button>
          ) : !YBZFUploadflag ? (
            <Space>
              {status === RecipeStatus.Settled && (
                <Button
                  size='small'
                  type='primary'
                  onClick={() => onAction('return', t.id, t)}
                >
                  退费
                </Button>
              )}
              {oweMoneyShow &&
                oweMoneyShow?.openOwe == 1 &&
                t.accountingStatus === 1 &&
                status === RecipeStatus.Settled && (
                  <Button
                    size='small'
                    type='primary'
                    onClick={() => onAction('supplementary', t.id, t)}
                  >
                    补交
                  </Button>
                )}

              <a onClick={() => onAction('detail', t.id, t)}>查看详情</a>
              {status === RecipeStatus.Returned && (
                <Button
                  size='small'
                  type='primary'
                  onClick={() => onAction('payAgain', t.id, t)}
                >
                  重新收费
                </Button>
              )}
            </Space>
          ) : (
            <Button
              size='small'
              type='primary'
              onClick={() =>
                onAction(
                  t.treatment.zfUploadFlag === 0 ? 'upload' : 'repeal',
                  t.id,
                  t
                )
              }
            >
              {t.treatment.zfUploadFlag === 0 ? '上传' : '撤销'}
            </Button>
          )
        }
      },
    },
  ]
  return status === RecipeStatus.Settled
    ? colums.filter((v) => v.key != 'payTime')
    : colums.filter(
      (v) =>
        v.key != 'invoiceType' &&
        v.key != 'invoiceNo' &&
        v.title != '欠费实收金额' &&
        v.title != '结算状态' &&
        v.key != 'payee'
    )
}

export const ChargeAgainColumn = (
  changeCount?: (m?: any, v?: any) => void
): TableColumnType<Payment>[] => {
  const colums: TableColumnType<Payment>[] = [
    {
      title: '处方名称',
      key: 'name',
      align: 'center',
      width: '10rem',
      render: (_, m: any) => m.name,
    },
    {
      title: '规格',
      key: 'spec',
      align: 'center',
      width: '8rem',
      render: (_, r: any) => r.packSpec,
    },
    {
      title: '单价',
      key: 'retailPrice',
      width: '8rem',
      align: 'center',
      render: (_, r: any) => r.retailPrice?.toFixed(5),
    },
    {
      title: '退费数量',
      dataIndex: 'drugCount',
      width: '8rem',
      align: 'center',
      key: 'drugCount',
      render: (_, m: any) => {
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '3rem' }}>{m.drugCount}</div>
            <div style={{ width: '1rem' }}>|</div>
            <div style={{ width: '3rem' }}>
              {m.splitTag ? m.splitUnit : m.accountUnit}
            </div>
          </div>
        )
      },
    },
    {
      title: '重收数量',
      key: '',
      align: 'center',
      width: '8em',
      render: (_, m: any) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className={styles.inputStyle}
          >
            <Button
              icon={<MinusOutlined />}
              size='small'
              onClick={() => {
                const v = m?.recoveryQuantity - 1
                if (v <= 0) {
                  notification.info({
                    message: '重收数量不能为0',
                  })
                } else {
                  changeCount && changeCount(m, v)
                }
              }}
            />
            <InputNumber
              style={{
                width: '3.5rem',
                display: 'flex',
                justifyContent: 'center',
                fontSize: '1rem',
                fontWeight: 'bold',
              }}
              controls={false}
              value={m?.recoveryQuantity}
              min={1}
              max={9999}
              bordered={false}
            />
            <Button
              icon={<PlusOutlined />}
              size='small'
              onClick={() => {
                const v = m?.recoveryQuantity + 1
                changeCount && changeCount(m, v)
              }}
            />
          </div>
        )
      },
    },
    {
      title: '收费金额',
      key: 'drugAmount',
      align: 'center',
      width: '8em',
      render: (_, r: any) => r.drugAmount?.toFixed(2),
    },
  ]
  return colums
}

export const ChargeAgainTCMColumn = (
  changeCount?: (m?: any, v?: any) => void,
  recoveryTip?: any
): TableColumnType<Payment>[] => {
  const colums: TableColumnType<Payment>[] = [
    {
      title: '处方名称',
      key: 'name',
      align: 'center',
      width: '10rem',
      render: (_, m: any) => m.name,
    },
    {
      title: '规格',
      key: 'spec',
      align: 'center',
      width: '8rem',
      render: (_, r: any) => r.packSpec,
    },
    {
      title: '单价',
      key: 'retailPrice',
      width: '8rem',
      align: 'center',
      render: (_, r: any) => r.retailPrice?.toFixed(5),
    },
    {
      title: '原单每帖数量',
      dataIndex: 'drugCount',
      width: '8rem',
      align: 'center',
      key: 'drugCount',
      render: (_, m: any) => {
        return (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '3rem' }}>
              {m.countPerTip <= 0 ? '' : `${m.countPerTip}`}
            </div>
            <div style={{ width: '1rem' }}>|</div>
            <div style={{ width: '3rem' }}>
              {m.splitTag ? m.splitUnit : m.accountUnit}
            </div>
          </div>
        )
      },
    },
    {
      title: '重开每帖数量',
      key: '',
      align: 'center',
      width: '8em',
      render: (_, m: any) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className={styles.inputStyle}
          >
            <Button
              icon={<MinusOutlined />}
              size='small'
              onClick={() => {
                const v = m?.recoveryQuantity <= 0 ? 0 : m?.recoveryQuantity - 1
                if (v <= 0) {
                  notification.info({
                    message: '重开每帖数量不能为0',
                  })
                } else {
                  changeCount && changeCount(m, v)
                }
              }}
            />
            <InputNumber
              style={{
                width: '3.5rem',
                display: 'flex',
                justifyContent: 'center',
                fontSize: '1rem',
                fontWeight: 'bold',
              }}
              controls={false}
              value={m?.recoveryQuantity}
              min={1}
              max={9999}
              bordered={false}
            />
            <Button
              icon={<PlusOutlined />}
              size='small'
              onClick={() => {
                const v = m?.recoveryQuantity <= 0 ? 0 : m?.recoveryQuantity + 1
                changeCount && changeCount(m, v)
              }}
            />
          </div>
        )
      },
    },
    {
      title: '收费金额',
      key: 'drugAmount',
      align: 'center',
      width: '8em',
      render: (_, r: any) => r.drugAmount?.toFixed(2),
    },
  ]
  return colums
}

// 操作列渲染器（模块级稳定引用，避免内联 cellRendererFramework 每次渲染被 ag-grid 销毁重建）
const ActionCellRenderer = (props: any) => {
  const {
    data: t,
    node,
    status,
    onAction,
    YBZFUploadflag,
    LSCFSHflag,
    auditButtonLoading,
    oweMoneyShow,
  } = props

  if (node?.rowPinned) return ''
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {status === RecipeStatus.ToSettle ? (
        <Button
          size='small'
          type='primary'
          onClick={() => onAction('pay', t?.treatment?.id, t, t?.settlementCategory)}
        >
          结算
        </Button>
      ) : LSCFSHflag ? (
        <Button
          loading={auditButtonLoading}
          disabled={auditButtonLoading}
          size='small'
          type='primary'
          onClick={() => onAction('check', t.id, t)}
        >
          审核
        </Button>
      ) : !YBZFUploadflag ? (
        <Space>
          {status === RecipeStatus.Settled && (
            <Button
              size='small'
              type='primary'
              onClick={() => onAction('return', t.id, t)}
            >
              退费
            </Button>
          )}
          {oweMoneyShow &&
            oweMoneyShow?.openOwe == 1 &&
            t.accountingStatus === 1 &&
            status === RecipeStatus.Settled && (
              <Button
                size='small'
                type='primary'
                onClick={() => onAction('supplementary', t.id, t)}
              >
                补交
              </Button>
            )}
          <Button
            type='link'
            size='small'
            onClick={() => onAction('detail', t.id, t)}
          >
            查看详情
          </Button>
          {status === RecipeStatus.Returned && (
            <Button
              size='small'
              type='primary'
              onClick={() => onAction('payAgain', t.id, t)}
            >
              重新收费
            </Button>
          )}
        </Space>
      ) : (
        <Button
          size='small'
          type='primary'
          onClick={() =>
            onAction(t.treatment.zfUploadFlag === 0 ? 'upload' : 'repeal', t.id, t)
          }
        >
          {t.treatment.zfUploadFlag === 0 ? '上传' : '撤销'}
        </Button>
      )}
    </div>
  )
}

export const AGColumns = (
  status: PaymentStatus,
  startIndex: number,
  onAction: (
    action: Action,
    id: any,
    t: any,
    settlementCategory?: number
  ) => void,
  YBZFUploadflag?: boolean,
  LSCFSHflag?: boolean,
  auditButtonLoading?: any,
  columnList?: any,
  arrearageAmount?: any,
): ColDef[] => {
  const oweMoneyShow: any = useSelector(selectTenant) //欠费是否显示

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'outpatientNo': //门诊号
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center'
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '合计';
              const t = params.data;
              const field = item.field;
              const val = Number(t?.registration?.[field]);
              return val ? val : '-';
            },
          };
        case 'patientName': //患者姓名
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const treatment = t?.treatment;
              const labels = t?.labels || [];
              const arrearageAmountSum = t?.arrearageAmount || 0;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  <div
                    style={{ textAlign: 'left', marginRight: '10px' }}
                    >
                      {treatment.patientName}
                  </div>
                  <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {arrearageAmountSum > 0 &&
                        oweMoneyShow &&
                        oweMoneyShow?.openOwe == 1 && (
                          <Tooltip title={`欠费金额 ${arrearageAmountSum} 元`}>
                            <span
                              style={{
                                width: '18px',
                                height: '18px',
                                lineHeight: '18px',
                              }}
                            >
                              <OweMoneyIcon
                                style={{
                                  marginRight: '3px',
                                  width: '18px',
                                  height: '18px',
                                }}
                              />
                            </span>
                          </Tooltip>
                        )}
                      {!!labels?.length &&
                        labels?.map((v: any) => (
                          <Tooltip key={v.id} title={v.name}>
                            <span
                              className={styles.label}
                              style={{
                                backgroundColor: v.backgroundColor,
                                color: v.fontColor,
                                borderRadius: '50%',
                              }}
                            >
                              {v.headName}
                            </span>
                          </Tooltip>
                        ))}
                  </div>
                </div>
              );
            }
          };
        case 'patientId': //病历号
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = Number(t?.registration?.[field]);
              return val ? val : '-';
            },
          };
        case 'insuranceCode': //结算险种
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              // 已收费列表使用结算时的险种 paymentInsuranceCode，其余列表使用挂号险种 registration.insuranceCode
              const val =
                status != RecipeStatus.ToSettle
                  ? t?.paymentInsuranceCode
                  : t?.registration?.[field];
              return val === 'ZIFEI' || !val ? '自费' : '智慧医保';
            },
          };
        case 'cardType': //读卡方式
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.registration?.[field];
              return getCardType(val) || '-';
            },
          };
        case 'patientSex': //性别
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.treatment?.[field];
              return getGenderName(val) || '-';
            },
          };
        case 'patientAge': //年龄
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getAge(t?.treatment?.patientAge, t?.treatment?.patientMonth) || '-';
            },
          };
        case 'disease': //诊断疾病
        case 'treatmentDepartmentName': //接诊科室
        case 'treatmentDoctorName': //接诊医生
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.treatment?.[field];
              return val ? val : '-';
            },
          };
        case 'amount': //总金额
        case 'insurancePayAmount': //报销金额
        case 'realPayAmount': //现金金额
        case 'shouldPayAmount': //应收现金金额
        case 'discountAmount': //优惠金额
        case 'totalRealAmount': //实收总金额
        case 'shouldPayTotalAmount': //应收总金额
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
              };
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field]);
              return val === undefined ? '' : val ? val?.toFixed(2) : '0.00'
            },
          };
        case 'arrearageAmount': //欠费金额
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return status == RecipeStatus.Returned ? '' : arrearageAmount
              const t = params.data;
              const field = item.field;
              const accountingStatus = t?.accountingStatus
              const val = Number(t?.[field]);
              return accountingStatus === 0 ? '-' : (val === undefined ? '' : val?.toFixed(2))
            },
          };
        case 'payeeName': //收款人
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.treatment?.[field];
              return val ? val : '-';
            },
          };
        case 'orderSource': //订单来源
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              return getOrderSource(val) || '-';
            },
          };
        case 'settlementCategory': //收费标志
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.treatment?.[field];
              return getPayFlagName(val) || '-';
            },
          };
        case 'accountingStatus': //结算状态
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              return val === 0 ? '已结清' : '欠费中'
            },
          };
        case 'registrationTime': //挂号时间
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.registration?.[field];
              return val ? val : '-';
            },
          };
        case 'payTime': //收费时间
        case 'chargeOrRefundTime': //退费时间
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.treatment?.[field];
              return val ? val : '-';
            },
          };
        case 'payMethodName': //支付方式
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              return val ? val : '-';
            },
          };
        case 'invoiceType': //发票类型
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.invoiceDetails?.[field];
              return getInvoiceType(val) || '-';
            },
          };
        case 'invoiceNum': //发票号
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.invoiceDetails?.[field];
              return val ? val : '-';
            },
          };
        case 'action':
          return {
            ...item,
            flex: 0, // 固定列退出 flex，使用固定宽度（否则 defaultColDef.flex:1 会覆盖 width）
            cellStyle: { textAlign: 'center', },
            cellRendererFramework: ActionCellRenderer,
            cellRendererParams: {
              status,
              onAction,
              YBZFUploadflag,
              LSCFSHflag,
              auditButtonLoading,
              oweMoneyShow,
            },
          };
        default:
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                minHeight: '68px', display: 'flex', alignItems: 'center', justifyContent: 'center'
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              return val ? val : '-';
            },
          };
      }
    })
  )
}